import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
import React from 'react';
import { BarChart } from 'components/Charts';
import Card from 'components/Card';
import Heading from 'components/Heading';
import Box from 'components/Box';
import Flex from 'components/Flex';
function BarChartCard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    chartProps = _objectWithoutProperties(_ref, _excluded);
  var titleIdValue = titleId || 'bar-chart-card-title';
  return /*#__PURE__*/React.createElement(Card, {
    role: "region",
    "aria-labelledby": titleIdValue
  }, /*#__PURE__*/React.createElement(Flex, {
    column: true,
    align: "stretch",
    height: "100%",
    gap: "xs"
  }, title && /*#__PURE__*/React.createElement(Box, {
    py: "s",
    px: "m"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    id: titleIdValue
  }, title)), /*#__PURE__*/React.createElement(Box, {
    px: "s",
    mb: "s",
    mt: title ? 0 : 'm',
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(BarChart, chartProps))));
}
export default BarChartCard;